import React from "react";
import WebResourceImage from "../../WebResourceImage";
import { CanotisBOSIco, DatabaseIco } from "../../../localResouces";

// DevExtreme components
import { Accordion, Button } from 'devextreme-react';

// Component styles
import classes from "./Groups.module.scss";

function Solutions(props) {
  const { solutions, currentDataSegmentId, onDataClick, openHint } = props;

  function CustomTitle(solution) {
    return (
      <div style={{ display: "flex" }}>
        <WebResourceImage size={"32px"} fallBackImage={CanotisBOSIco} fileId={solution.iconExternalDocId} />
        <div style={{ placeSelf: "center" }} >{solution.displayName}</div>
      </div>
    );
  }

  function CustomItem(solution) {
    return (
      solution.datas.map((data, index) => (
        <Button
          key={index}
          stylingMode={"text"}
          hint={openHint}
          disabled={data.globalDatasegmentId === currentDataSegmentId}
          onClick={e => onDataClick(e, solution, data)}
        >
          <div style={{ display: "flex" }}>
            <WebResourceImage size={"22px"} fallBackImage={DatabaseIco} fileId={data.iconExternalDocId} />
            <div style={{ placeSelf: "center" }} className={'dx-theme-accent-as-text-color'} >{data.displayName}</div>
          </div>
        </Button>
      ))
    );
  }

  const renderSolutions = () => {
    if (solutions) {
      return (
        <Accordion
          dataSource={solutions}
          collapsible={true}
          multiple={true}
          itemTitleRender={CustomTitle}
          itemRender={CustomItem}
        />
      );
    }
  };

  return (
    <div className={classes.groupDiv}>
      {renderSolutions()}
    </div>
  );
}

export default (Solutions);
